<template>
<div class="container">
    <div class="text-center">
        <h2 class="hk-body-bold my-5">{{ $t('client_logo_heading.client_logo_heading') }} </h2>
    </div>
    <div class="logos">

        <div class="logo_items " ref="logoItems">
            <!-- Repeating logos using v-for -->
            <img v-for="(logo, index) in logos" :key="index" :src="logo" alt="Logo" loading="lazy">
        </div>
        <div class="logo_items" ref="logoItems">
            <img v-for="(logo, index) in logos" :key="index + logos.length" :src="logo" alt="Logo" loading="lazy">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'ClientLogos',
    data() {
        return {
            logos: [
                require('@/assets/enterprises_client_logo/hilton.svg'),
                require('@/assets/enterprises_client_logo/redroof.svg'),
                require('@/assets/enterprises_client_logo/ihg-logo.svg'),
                require('@/assets/enterprises_client_logo/oyo.svg'),
                require('@/assets/enterprises_client_logo/g6.svg'),
                require('@/assets/enterprises_client_logo/intown_suites.svg'),
                require('@/assets/enterprises_client_logo/esa.svg'),
                require('@/assets/enterprises_client_logo/ymca_rockies_logo.svg'),
                require('@/assets/enterprises_client_logo/livaway_suites.svg'),
                require('@/assets/enterprises_client_logo/acc.svg'),

                require('@/assets/enterprises_client_logo/hilton.svg'),
                require('@/assets/enterprises_client_logo/redroof.svg'),
                require('@/assets/enterprises_client_logo/ihg-logo.svg'),
                require('@/assets/enterprises_client_logo/oyo.svg'),
                require('@/assets/enterprises_client_logo/g6.svg'),
                require('@/assets/enterprises_client_logo/intown_suites.svg'),
                require('@/assets/enterprises_client_logo/esa.svg'),
                require('@/assets/enterprises_client_logo/ymca_rockies_logo.svg'),
                require('@/assets/enterprises_client_logo/livaway_suites.svg'),
                require('@/assets/enterprises_client_logo/acc.svg'),

                require('@/assets/enterprises_client_logo/hilton.svg'),
                require('@/assets/enterprises_client_logo/redroof.svg'),
                require('@/assets/enterprises_client_logo/ihg-logo.svg'),
                require('@/assets/enterprises_client_logo/oyo.svg'),
                require('@/assets/enterprises_client_logo/g6.svg'),
                require('@/assets/enterprises_client_logo/intown_suites.svg'),
                require('@/assets/enterprises_client_logo/esa.svg'),
                require('@/assets/enterprises_client_logo/ymca_rockies_logo.svg'),
                require('@/assets/enterprises_client_logo/livaway_suites.svg'),
                require('@/assets/enterprises_client_logo/acc.svg'),

            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

@keyframes slides {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

.logos {
    overflow: hidden;
    padding: 0px 0;
    white-space: nowrap;
    position: relative;

}

.logos:before,
.logos:after {
    position: absolute;
    top: 0;
    content: '';
    width: 150px;
    height: 100%;
    z-index: 2;
}

.logos:before {
    left: 0;
    background: linear-gradient(to left, rgba(255, 255, 255, 0), rgb(255, 255, 255));
}

.logos:after {
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255));
}

.logo_items {
    display: inline-block;
    animation: 60s slides infinite linear;
}

.logo_items img {
    height: 75px;
    margin: 10px 50px;
}

.logo_items img:last-child {
    margin-right: 0;
}

@media (max-width: 575.98px) {
    .heading {
        font-size: 1.5rem;
        font-weight: 700;
    }

    .logo_items img {
        height: 75px;
        margin: 10px 25px;
    }
}
</style>
